import { hydrate } from "svelte";
import {
  islandsOptions,
  navigatorOptions,
  rootComponent,
  experimental,
} from "@kestrel/internal/client";
import type * as Module from "@kestrel/entry";
import { onReady } from "@otto-ec/global-resources/dom";
import { resolveComponentFromRouteId } from "../component/resolve.js";
import { createStores } from "../stores/index-universal.js";
import { initNavigator } from "../navigator/init.js";
import { getComponentUpdater } from "../component/component.js";
import { noop } from "../../utils/function.js";
import {
  hydrateIslandsIfAllRegistered,
  propagateIslandsFromEntrypoint,
  registerIslandEntrypoint,
} from "../islands/islands.js";
import { createRootContext } from "../context/rootContext.js";

/**
 *
 */
export const add = islandsOptions ? registerIslandEntrypoint : noop;

/**
 *
 *
 *
 *
 */
export const start = (async (
  current,
  ssrState,
  delayHydration = experimental.useDelayedHydration,
) => {
  const container = current.parentElement;
  if (import.meta.env.DEV && !container) {
    throw new Error("current script element is not attached to a parent");
  }

  if (import.meta.env.DEV && !ssrState.routeId && !ssrState.error) {
    throw new Error("Invalid ssr state, missing routeId");
  }

  /*                                                                     */
  /*                                                        */
  if (experimental.useDelayedHydration && delayHydration) {
    return void onReady.subscribe(() => start(current, ssrState, false), { once: true });
  }

  /*                                              */
  const resolvedComponent = await resolveComponentFromRouteId(ssrState.routeId, ssrState.error);

  /*                                                */
  /*                                                             */
  const stores = createStores(ssrState, resolvedComponent);

  /*                                                                              */
  if (islandsOptions) {
    propagateIslandsFromEntrypoint(current);
    hydrateIslandsIfAllRegistered(stores, ssrState, resolvedComponent);
  }
  /*                                                                                */
  else {
    hydrate(rootComponent, {
      target: container!,
      props: { component: resolvedComponent[0] },
      context: createRootContext(stores),
    });
  }

  /*                                         */
  if (navigatorOptions) {
    /*                                        */
    stores.navigate.subscribe(getComponentUpdater(stores));

    /*                                        */
    initNavigator(stores);
  }

  /*                                        */
  current.remove();
}) satisfies typeof Module.start;
